export const APM_A2A_BUTTON_CONFIG = {
  backgroundColor: "#389c74",
  height: "40px",
  text: "Pay by Bank",
  textColor: "#fff",
  width: "100px",
};
